import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthServiceService {
  private readonly baseUrl: string = `${environment.apiUrl}/OPRAG/v0/endpoint`;

  constructor(private httpClient: HttpClient) { }

  login(authRequest: any) {
    return this.httpClient.post(`${this.baseUrl}/auth/authenticate`, { username: authRequest.username, motDePasse: authRequest.motDePasse })
  }

  register(registerRequest: any) {
    return this.httpClient.post(`${this.baseUrl}/auth/register`, registerRequest)
  }

  update(user: any) {
    return this.httpClient.post(`${this.baseUrl}/auth/update`, user)
  }

}
